module.exports = __webpack_public_path__ + "static/img/logo_login.8fb97b45.png";